/* eslint-disable jsx-a11y/anchor-is-valid */
import { DeleteOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { updateInSpectionD7 } from 'pages/BillingProcess/slices';
import { deleteInSpection } from 'pages/BillingProcess/thunk';
import { useDispatch } from 'react-redux';

type Props = {
  dataDate: any;
  dataNew: any[];
  setSubmit: any;
  statusBill: boolean | undefined;
};

const TableDataUser = ({ dataDate, dataNew, setSubmit, statusBill }: Props) => {
  const dispatch = useDispatch();
  const onClick = (index: number, i_id: string, position?: number) => {
    const dataSource = [...dataNew];
    const fIndex = dataNew.findIndex((f) => f.position === position);
    if (fIndex > -1) {
      dataSource.splice(fIndex, 1);
      setSubmit(dataSource);
    } else {
      dispatch(deleteInSpection(i_id));
      dispatch(updateInSpectionD7({ index: index }));
    }
  };

  const columns: any = [
    {
      title: 'ご利用者名',
      dataIndex: 'name',
      key: 'name',
      width: '20%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: 'CPAP請求月',
      dataIndex: 'inspection_day',
      key: 'inspection_day',
      width: '20%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left', background: 'rgba(246, 246, 246, 1)' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '備考',
      dataIndex: 'simple_inspection_remark',
      key: 'simple_inspection_remark',
      width: '50%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },

    {
      title: '',
      key: '1',
      dataIndex: 'button',
      width: '10%',
      align: 'center',
      render(text: string, row: any, index: number) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'center', borderLeft: '2px solid white' },
            className: 'standardFont',
          },
          children: (
            <div>
              {statusBill ? null : (
                <a
                  style={{
                    backgroundColor: '#F6F6F6',
                    width: '65px',
                    color: 'black',
                    border: 'none',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                  }}
                  type="button"
                  onClick={() => onClick(index, row.item_ref?.name?.i_id, row.position ?? -1)}
                >
                  削除
                  <DeleteOutlined style={{ marginBottom: '4px' }} />
                </a>
              )}
            </div>
          ),
        };
      },
    },
  ];

  return (
    <div>
      <Table
        locale={{
          emptyText: <span style={{ color: 'gray' }}>利用なし</span>,
        }}
        onRow={() => {
          return {
            // onClick: () => {
            //   moveTo();
            // },
          };
        }}
        columns={columns}
        dataSource={dataDate}
        pagination={false}
      />
    </div>
  );
};

export default TableDataUser;
